import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Building2, Users, LogOut, Shield, Settings } from 'lucide-react';
import { Button } from './ui/button';
import { Logo } from './Logo';

const menuItems = [
  { path: '/superadmin/empresas', label: 'Empresas de Transporte', icon: Building2 },
  { path: '/superadmin/administradores', label: 'Administradores', icon: Users },
  { path: '/superadmin/configuracion', label: 'Configuración', icon: Settings },
];

export const SuperAdminLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <aside className="w-64 bg-slate-900 text-white flex flex-col">
        {/* Logo - usa el logo de plataforma */}
        <div className="h-[73px] flex items-center justify-center border-b border-slate-700 bg-white px-4">
          <Logo size="large" variant="plataforma" className="w-full" />
        </div>

        {/* Menu */}
        <nav className="flex-1 p-4 space-y-1">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                  isActive
                    ? 'bg-orange-600 text-white'
                    : 'text-slate-300 hover:bg-slate-800 hover:text-white'
                }`}
              >
                <Icon size={20} />
                <span className="text-sm font-medium">{item.label}</span>
              </Link>
            );
          })}
        </nav>

        {/* Logout */}
        <div className="p-4 border-t border-slate-700">
          <Button
            variant="ghost"
            className="w-full justify-start text-slate-300 hover:text-white hover:bg-slate-800"
            onClick={handleLogout}
          >
            <LogOut size={20} className="mr-3" />
            Cerrar Sesión
          </Button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <header className="h-[73px] bg-white border-b border-gray-200 flex items-center justify-between px-6">
          <h1 className="text-xl font-semibold text-gray-800">
            Panel de Super Administrador
          </h1>
          <div className="flex items-center gap-4">
            <span className="text-sm text-gray-600">{user?.nombre}</span>
            <div className="w-10 h-10 rounded-full bg-slate-900 flex items-center justify-center">
              <Shield className="text-orange-500" size={20} />
            </div>
          </div>
        </header>

        {/* Content */}
        <main className="flex-1 p-6 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
};
